import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const InfoTab = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 18 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.84351 4.30982C9.49948 4.30982 10.0312 3.77804 10.0312 3.12207C10.0312 2.4661 9.49948 1.93433 8.84351 1.93433C8.18753 1.93433 7.65576 2.4661 7.65576 3.12207C7.65576 3.77804 8.18753 4.30982 8.84351 4.30982ZM6.64534 6.18643C6.3692 6.18643 6.14534 6.41028 6.14534 6.68643C6.14534 6.96257 6.3692 7.18643 6.64534 7.18643H8.66275V14.2037H6.14111C5.86497 14.2037 5.64111 14.4276 5.64111 14.7037C5.64111 14.9799 5.86497 15.2037 6.14111 15.2037H9.16275H12.1919C12.468 15.2037 12.6919 14.9799 12.6919 14.7037C12.6919 14.4276 12.468 14.2037 12.1919 14.2037H9.66275V6.68643C9.66275 6.41028 9.43889 6.18643 9.16275 6.18643H6.64534Z"
      />
    </svg>
  )
})

export default InfoTab
